import React, { useState } from "react";
import { Box, TextField, Typography, Modal } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SaveButton, CloseButton } from "../../common/Buttons";
import { useParams } from "react-router-dom";
import axios from "axios";
import TPC_URL from "../../../utils/TPC_URL";

const createUrl = `${TPC_URL}/api/material/create`;

const ModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.paper,
  borderRadius: "8px",
  boxShadow: 24,
  padding: theme.spacing(4),
}));

function CreateMaterialModal({
  table,
  openSnackbar,
  open = true,
  setUpdateStatus,
}) {
  const { group_code, project_code } = useParams();
  const [materialName, setMaterialName] = useState("");
  const [materialDescription, setMaterialDescription] = useState("");
  const [defaultUnit, setDefaultUnit] = useState("EA");
  const [validationErrors, setValidationErrors] = useState({
    material_name: false,
    material_description: false,
  });
  const handleNameChange = (e) => {
    const value = e.target.value;
    setMaterialName(value);
    setValidationErrors({
      ...validationErrors,
      material_name: !value?.trim(),
    });
  };
  const handleUnitChange = (e) => {
    const value = e.target.value;
    setDefaultUnit(value);
    setValidationErrors({
      ...validationErrors,
      material_name: !value?.trim(),
    });
  };
  const handleDescChange = (e) => {
    const value = e.target.value;
    setMaterialDescription(value);
    setValidationErrors({
      ...validationErrors,
      material_description: false,
    });
  };
  const handleSave = async () => {
    if (!materialName || !materialName.toString().trim()) {
      openSnackbar("자재명을 입력해 주세요.", "warning");
      setValidationErrors((prev) => ({ ...prev, material_name: true }));
      return;
    }
    try {
      const payload = {
        group_code,
        project_code,
        materialName,
        materialDescription,
        defaultUnit,
      };
      const res = await axios.post(createUrl, payload);
      if (res.status === 200) {
        openSnackbar(res.data.message, "success");
      }
    } catch (e) {
      openSnackbar(e.response.data.message, "error");
    } finally {
      table.setCreatingRow(null);
      setUpdateStatus((prev) => !prev);
    }
  };
  const handleClose = () => {
    setMaterialName("");
    setMaterialDescription("");
    setValidationErrors({
      material_name: false,
      material_description: false,
    });
    table.setCreatingRow(null);
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <ModalContainer>
        <Typography variant="h6" component="h2" mb={3}>
          자재 등록
        </Typography>
        <TextField
          label="자재명"
          fullWidth
          autoFocus
          name="material_name"
          value={materialName}
          onChange={handleNameChange}
          sx={{ mb: 3 }}
          error={validationErrors.material_name}
          helperText={
            validationErrors.material_name ? "이름을 입력해 주세요." : ""
          }
        />
        <TextField
          label="단위"
          fullWidth
          name="default_unit"
          value={defaultUnit}
          onChange={handleUnitChange}
          sx={{ mb: 3 }}
        />
        <TextField
          label="자재설명"
          fullWidth
          name="material_description"
          value={materialDescription}
          onChange={handleDescChange}
          sx={{ mb: 3 }}
          multiline
          rows={3}
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <SaveButton onClick={handleSave} />
          <CloseButton
            variant="outlined"
            onClick={handleClose}
            color="inherit"
          />
        </Box>
      </ModalContainer>
    </Modal>
  );
}

export default CreateMaterialModal;
